<template>
  <v-container>
    <row-header action="back" :msg="msgRowHeader"></row-header>

    <v-row dense>
      <v-col>
        <v-form
            ref="form"
            v-model="valid"
        >
          <v-card>
            <merchant-product-form-component
                :merchant_product_model="merchant_product_model"
                :cat_prod="cat_prod"
                :merchant_prod="merchant_prod"
                :isAdmin="isAdmin"
                update="0"
            />
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  :disabled="!valid"
                  color="success"
                  @click="saveData"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>

    <v-overlay
        :absolute="absolute"
        :value="overlay"
    >
      <v-card color="white">
        <v-card-text>
          <overlay-img></overlay-img>
        </v-card-text>
      </v-card>
    </v-overlay>

  </v-container>
</template>

<script>
import RowHeader from "../../../components/content/RowHeader";
import OverlayImg from "../../../components/content/OverlayImg";
import MerchantProductFormComponent from '../../../components/page/merchant-products/MerchantProductFormComponent';
import { MerchantProductData } from '../../../store/services/MerchantProductModel';
import { PostRequest, GetRequest } from "../../../store/services/users";

export default {
  components: {
    RowHeader,
    OverlayImg,
    MerchantProductFormComponent,
  },
  data:() => ({
    msgRowHeader: {newUser: 'Back', newMsg: 'Create Merchant Product'},
    valid: true,
    absolute: false,
    overlay: false,
    merchant_product_model: new MerchantProductData(),
    cat_prod: [],
    merchant_prod: [],
    isAdmin: false,
  }),
  async mounted() {
    console.log('product new page');
    if (this.$store.getters.currentUser.role.level === 1) {
      this.isAdmin = true;
    }
    if (this.$store.getters.isLoggedIn && this.$store.getters.currentUser.role.level <= 2) {
      this.cat_prod = await this.getCatData();
      this.merchant_prod = await this.getMerchantData();
      if (this.$store.getters.currentUser.role.level === 2) {
        this.merchant_prod.forEach(val => {
          if (val.code === this.$store.getters.currentUser.bank_code) {
            this.merchant_product_model.merchant = val;
          }
        });
      }
    }
  },
  methods: {
    async getCatData() {
      await this.$store.dispatch('req_data');
      this.overlay = await this.$store.getters.isLoading;
      try{
        let response = await GetRequest('categories');
        await this.$store.dispatch('req_success');
        this.overlay = await this.$store.getters.isLoading;
        return response.data;
      }catch(err){
        await this.$store.dispatch('req_failed');
        this.overlay = await this.$store.getters.isLoading;
        alert('failed to get data : ' + err.message);
        return [];
      }
    },
    async getMerchantData() {
      await this.$store.dispatch('req_data');
      this.overlay = await this.$store.getters.isLoading;
      try{
        let response = await GetRequest('merchants');
        await this.$store.dispatch('req_success');
        this.overlay = await this.$store.getters.isLoading;
        return response.data;
      }catch(err){
        await this.$store.dispatch('req_failed');
        this.overlay = await this.$store.getters.isLoading;
        alert('failed to get data : ' + err.message);
        return [];
      }
    },
    async saveData() {
      delete this.merchant_product_model.category?.__v;
      delete this.merchant_product_model.merchant?.__v;
      this.merchant_product_model.up_selling_price = Number(this.merchant_product_model.up_selling_price);
      await this.$store.dispatch('req_data')
      this.overlay = this.$store.getters.isLoading;
      try {
        await PostRequest('merchant-products', this.merchant_product_model);
        this.overlay = this.$store.getters.isLoading;
        await this.$store.dispatch('req_success');
        this.overlay = this.$store.getters.isLoading;
        alert('Create data success');
        await this.$router.push({name: 'MerchantProductList'});
      } catch (e) {
        await this.$store.dispatch('req_failed');
        this.overlay = this.$store.getters.isLoading;
        alert('Create data failed ' + e.message);
      }
    }
  }
}
</script>

<style scoped>

</style>
